import type {
  GetJobsRequest,
  GetJobsResponse,
} from "../../../domain/types/company-job";
import { GetJobsResponseSchema } from "../../../domain/types/company-job";
import type { CompanyJobRepository } from "../../../domain/repositories/company/company-job-repository";
import { companyJobApiService } from "../../api/company/company-job-api-service";
import { companyMachineApiService } from "../../api/company/company-machine-api-service";
import { MachineEntitySchema } from "../../../domain/types/machine";

export class CompanyJobRepositoryImpl implements CompanyJobRepository {
  async getJobs(request: GetJobsRequest): Promise<GetJobsResponse> {
    const response = await companyJobApiService.getJobs(request);

    if (response.data) {
      return GetJobsResponseSchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "작업 가져오기 실패.");
  }
}
